<script setup lang="ts">
import type { FreeTextSection, Theme } from './report-typing';

import { useUpdatedReportStore } from '@src/store/report-store';

import { computed } from 'vue';

defineProps<{
  section: FreeTextSection;
}>();

const reportStore = useUpdatedReportStore();
const theme = computed<Theme | null>(() => {
  const loadedTemplate = reportStore.getTemplate();
  return loadedTemplate?.theme ?? null;
});

const containerStyle = computed(() => {
  if (!theme.value) return {};
  return {
    padding: '0px',
  };
});

const titleStyle = computed(() => {
  if (!theme.value) return {};
  const sl = theme.value.fonts.sectionLabel;
  return {
    fontFamily: sl.family,
    fontSize: `${sl.size}px`,
    fontWeight: sl.weight,
    color: theme.value.colors.muted,
    textTransform: sl.uppercase ? 'uppercase' : 'none',
    letterSpacing: sl.letterSpacing ? `${sl.letterSpacing}px` : undefined,
    margin: '0 0 4px 0',
  };
});

const bodyStyle = computed(() => {
  if (!theme.value) return {};
  return {
    fontFamily: theme.value.fonts.body.family,
    fontSize: `${theme.value.fonts.body.size}px`,
    fontWeight: theme.value.fonts.body.weight,
    color: theme.value.colors.muted,
    lineHeight: '1.25',
    fontStyle: 'italic',
    margin: 0,
  };
});
</script>

<template>
  <div class="free-text-section" :style="containerStyle">
    <h3 v-if="section.title" class="free-text-title" :style="titleStyle">
      {{ section.title }}
    </h3>
    <p class="free-text-content" :style="bodyStyle">
      {{ section.text }}
    </p>
  </div>
</template>

<style scoped>
.free-text-section {
  display: flex;
  flex-direction: column;
}

.free-text-title {
  font-size: 11px;
  color: #666;
  font-weight: 600;
  margin: 0 0 4px 0;
}

.free-text-content {
  font-size: 10px;
  color: #666;
  line-height: 1.4;
  font-style: italic;
  margin: 0;
}
</style>
